import { render, staticRenderFns } from "./TabAccountSetting.vue?vue&type=template&id=0107f5bc&scoped=true&"
import script from "./TabAccountSetting.vue?vue&type=script&lang=js&"
export * from "./TabAccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107f5bc",
  null
  
)

export default component.exports